import dayjs from 'dayjs'
import { DATE_TIME_FORMAT, DEFAULT_TIMEZONE } from '../constants'
import { DEFAULT_LANGUAGE } from '../../../i18n/constants'

// Validate if the given string is a valid date
export const isValidDate = (dateString: string | Date): boolean => {
  if (!dateString) return false
  const parsedDate = dayjs(dateString)
  return parsedDate.isValid() && parsedDate.isAfter(dayjs('2000-01-01'))
}

export const convertToDateTime = (
  date: Date | string,
  format: string = DATE_TIME_FORMAT,
  locale: string = DEFAULT_LANGUAGE,
): string => {
  dayjs.locale(locale)
  return dayjs(date).tz(DEFAULT_TIMEZONE).format(format)
}

/**
 * Get the first day of the month exactly three months ago.
 * @param {Date} [date=new Date()] - Reference date (default: today)
 * @returns {Date} The first day of the month from three months ago (in UTC)
 */
export const getThreeMonthsAgo = (date: Date = new Date()): Date => {
  const threeMonthsAgo = dayjs(date).startOf('month').subtract(3, 'month')

  // Return date in UTC to avoid timezone issues
  return new Date(Date.UTC(threeMonthsAgo.year(), threeMonthsAgo.month(), 1))
}

export const formatDateTime = (
  format: string,
  dateTime?: Date | string,
  language?: string,
): string => {
  if (!dateTime) return ''
  return convertToDateTime(dateTime, format, language)
}
